import _ from 'lodash';
import moment from 'moment';
import { SettingValues } from 'common/services/settings.service';
import { CURRENCIES } from '@linearb/linjs-common';
import useSettingsService from 'components/hooks/useSettingsService';
import { getRoundedFte } from '../../../resource-allocation.formatters';

const useRaCostSetting = () => {
  const { updateSetting, getSettingOrDefinitionValue } = useSettingsService();
  const settingValue = getSettingOrDefinitionValue({
    name: SettingValues.RA_COST
  });

  const isEnabled = settingValue !== null;
  const value = _.get(settingValue, 'value');
  const currency = _.get(CURRENCIES, settingValue?.currency);

  const onSave = async ({ currency, value, isEnabled = true }) => {
    const settingPayload = isEnabled ? { currency, value } : null;
    await updateSetting(SettingValues.RA_COST, settingPayload);
  };

  const calculateCostByFte = ({ period, effortFte }) => {
    if (!isEnabled) return null;

    const diffInMonths = moment(period?.before)
      .endOf('day')
      .diff(moment(period?.after).startOf('day'), 'months', true);

    const diffPartOfYear = diffInMonths / 12;
    return _.round(effortFte * diffPartOfYear * value, 1);
  };

  const formatToString = (
    estCostValue,
    { kFormat = false, round = 1 } = {}
  ) => {
    if (isNaN(estCostValue)) return '';
    const amount = kFormat ? estCostValue / 1000 : estCostValue;
    const roundedAmount = getRoundedFte(amount, round);
    return `
      ${currency?.symbol}
      ${roundedAmount?.toLocaleString()}${kFormat ? 'k' : ''}
    `;
  };

  return {
    isEnabled,
    value,
    currency,
    onSave,
    calculateCostByFte,
    formatToString
  };
};

export default useRaCostSetting;
